/**
 * The default implementation of the Redux connect function's mapStateToProps.
 */
export const defaultMapStateToProps = (state, props) => props;


/**
 * The default implementation of the Redux connect function's mapDispatchToProps.
 */
export const defaultMapDispatchToProps = (dispatch, props) => props;


/**
 * The default implementation of the Redux connect function's mergeProps.
 */
export const defaultMergeProps = (
  stateProps,
  dispatchProps,
  ownProps,
) => ({ ...ownProps, ...stateProps, ...dispatchProps });
